export default "__VITE_ASSET__WBmuV9Gg__"